module.exports = __webpack_public_path__ + "img/tiktok.59b68074.svg";